import Vue from 'vue'
import Axios from 'axios'
import Qs from 'qs'
import setting from '@/setting'

var jwtHeader = window.AbJwtSetting.getHeader()
var headers = {}
if (jwtHeader) {
  headers[window.AbJwtSetting.headerName] = jwtHeader
}
var axios = Axios.create({
  baseURL: setting.apiBaseURL,
  timeout: '3000000', //请求超时时间
  //header传值，例如：Authorization
  headers: headers,
})

axios.defaults.withCredentials = true

axios.interceptors.request.use(function (request) {
  request.credentials = true
  return request
})

// 设置通用的拦截器
axios.interceptors.response.use(
  function (response) {
    if (response.data && !response.data.isOk && response.data.code === '401') {
      //Vue.prototype.$Message.error("登录超时，请重新登录");
      return response
    }
    if (response.data && !response.data.isOk && response.data.code === '403') {
      console.info(response)
      Vue.prototype.$Message.error('访问受限！')
      return response
    }
    return response
  },
  function (error) {
    //通用异常
    return Promise.reject(error)
  }
)

// Http Util 基础服务
var HttpUtil = {
  get: function (url) {
    return new Promise((resolve, reject) => {
      axios
        .get(url)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          console.log('请求失败：', error)
          reject(error)
        })
    })
  },
  post: function (url, data) {
    if (!data) data = {}

    return new Promise((resolve, reject) => {
      axios
        .post(url, data)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          console.log('请求失败：', error)
          reject(error)
        })
    })
  },

  postJson: function (url, data) {
    if (!data) data = {}
    return new Promise((resolve, reject) => {
      axios
        .post(url, data, {
          headers: {
            'Content-Type': 'application/json; charset=utf-8',
          },
        })
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          console.log('请求失败：', error)
          reject(error)
        })
    })
  },

  getResults: function (data) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/v0/business_statement/${data.table.from}`, data, {
          headers: {
            'Content-Type': 'application/json; charset=utf-8',
          },
        })
        .then((response) => {
          if (data.debug) {
            console.log('请求参数:', data)
            console.log('相应参数:', response.data)
            console.log('查询语句:', response.data.data.sql)
          }
          resolve(response.data)
        })
        .catch((error) => {
          console.log('请求失败：', error)
          reject(error)
        })
    })
  },

  postblob: function (url, data) {
    if (!data) data = {}

    return new Promise((resolve, reject) => {
      axios
        .post(url, data, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          responseType: 'blob',
        })
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          console.log('请求失败：', error)
          reject(error)
        })
    })
  },
  // form-data格式化
  postForm: function (url, data) {
    if (!data) data = {}
    return new Promise((resolve, reject) => {
      axios
        .post(url, data, {
          transformRequest: this.jsonToFormData,
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
          },
        })
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          console.log('请求失败：', error)
          reject(error)
        })
    })
  },
  // form-data格式化
  postFormAccessControlAllowOrigin: function (url, data) {
    if (!data) data = {}
    return new Promise((resolve, reject) => {
      axios
        .post(url, data, {
          headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'multipart/form-data',
          },
        })
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          console.log('请求失败：', error)
          reject(error)
        })
    })
  },

  jsonToFormData: function (data) {
    data = Qs.stringify(data, { arrayFormat: 'brackets' }) // qs.stringify(params)
    return data
  },
}

export default {
  // 全局安装时候
  install(Vue) {
    Vue.abHttpUtil = HttpUtil
    Vue.prototype.abHttpUtil = HttpUtil
    Vue.prototype.abAxios = axios
  },
}
